import _t, {_} from 'i18n'
import React from 'react'

import {Container, Icon, IconContainer, Label} from './styles'

function Type({iconSize = '8px', height = '20px', type, width = '20px'}) {
  const config = {
    city: {
      icon: 'fas fa-university',
      label: _`Pública`,
    },
    company: {
      icon: 'fas fa-building',
      label: _`Privada`,
    },
  }[type]

  return (
    <Container type={type}>
      <IconContainer type={type} height={height} width={width} style={{display: 'flex', alignItems: 'center'}}>
        <Icon className={config.icon} iconSize={iconSize} />
      </IconContainer>
      <Label type={type}>{config.label}</Label>
    </Container>
  )
}

export default Type
